// extracted by mini-css-extract-plugin
export var container = "_hw-0";
export var content = "_hw-3";
export var customerTitle = "_hw-4";
export var empty = "_hw-5";
export var gray = "_hw-6";
export var header = "_hw-7";
export var info = "_hw-8";
export var loading = "_hw-2";
export var loadingCard = "_hw-9";
export var oneLine = "_hw-a";
export var personName = "_hw-e";
export var pillContainer = "_hw-b";
export var selected = "_hw-1";
export var text = "_hw-c";
export var twoLines = "_hw-d";
export var unread = "_hw-f";
export var unreadIndicator = "_hw-g";